/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccreditationAmountProfessionalsAliases {
  DECK_AMOUNT_PROFESSIONALS = 'deck-amount-professionals',
  FETCH_AMOUNT_PROFESSIONALS = 'fetch-amount-professionals',
  FETCH_PENDENCIES = 'fetch-pendencies',
  FIELD_0 = 'field-0',
  FORM_0 = 'form-0',
  HPMS_AMOUNT_PROFESSIONALS_CARD = 'hpms-amount-professionals-card',
  LAYOUT_AMOUNT_PROFESSIONALS = 'layout-amount-professionals',
  MAPPER_0 = 'mapper-0',
  PANEL_1 = 'panel-1',
  PANEL_AMOUNT_PROFESSIONALS = 'panel-amount-professionals',
  PANEL_PENDENCIES = 'panel-pendencies',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { AccreditationAmountProfessionalsAliases };
